import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

function PODetailsPage() {
  const { id } = useParams();

  const [po, setPO] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchPO = async () => {
      try {
        const res = await authFetch(
  `${process.env.REACT_APP_API_URL}/po/${id}`
);
        const data = await res.json();

        console.log("PO DETAILS:", data);

        setPO(data);
        setItems(data.items || []);
      } catch (err) {
        console.error("Error fetching PO:", err);
      }
    };

    fetchPO();
  }, [id]);

  if (!po) {
    return <h3>Loading...</h3>;
  }

  return (
    <div style={{ padding: "20px" }}>
      <h2>Purchase Order Details</h2>

      <p><b>Order ID:</b> {po.order_id}</p>
      <p><b>Date:</b> {po.date}</p>
      <p><b>Vendor:</b> {po.vendor_name}</p>
      <p><b>Site:</b> {po.site_name}</p>

      <h3>Items</h3>

      <table border="1" cellPadding="10">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name</th>
            <th>Qty</th>
            <th>Rate</th>
            <th>Amount</th>
          </tr>
        </thead>

        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td>{item.qty}</td>
                <td>{item.rate}</td>
                <td>{item.qty * item.rate}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No Items Found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default PODetailsPage;